export default __webpack_public_path__ + "static/media/Educational-material.dd8d1143.jpg";